
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MemberPositioinTag',
  props: {
    position: String
  },
});
